import debug from "debug";
import plugin from '../../lib/plugin';
import { mustache } from '../../lib/strings';

const PLUGIN_NAME = 'sortableProducts';
const MODULE_NAME = 'app.core/modules/sortable-products';
const log = debug(MODULE_NAME);
const ELEMENT_SELECTOR = '[data-sortable-products]';
const CATEGORY_ID_SELECTOR = 'data-category-id';
const ID_SELECTOR = 'data-id';
const ID_ELEMENT_SELECTOR = '[data-id]';
const LOADING_PANEL_SELECTOR = '[data-sortable-products-loading]';
const CONTAINER_SELECTOR = '[data-sortable-products-container]';
const SAVE_SELECTOR = '[data-sortable-products-save]';
const RESET_SELECTOR = '[data-sortable-products-reset]';
const NO_RESULTS_SELECTOR = '[data-sortable-products-no-results]';
const CATEGORIES = 'data-sort-categories';
const TEMPLATE_SELECTOR = '#sortable-products-item-template';
const CATEGORY_TEMPLATE_SELECTOR = '#sortable-products-category-item-template';
const LOADING_PANEL_TOGGLE_CLASS = 'show';

import Sortable from '@vendor/sortablejs/Sortable';

class SortableProducts {
	constructor(element, options) {
		this.element = element;
		this.options = options;
		this.$element = $(element);
		this.categoryId = this.$element.attr(CATEGORY_ID_SELECTOR);
		this.$container = this.$element.closest(CONTAINER_SELECTOR);
		this.$loadingPanel = this.$container.find(LOADING_PANEL_SELECTOR);
		this.$saveButton = this.$container.find(SAVE_SELECTOR);
		this.$resetButton = this.$container.find(RESET_SELECTOR);
		this.$noResults = this.$container.find(NO_RESULTS_SELECTOR);
		this.categoryMode = typeof(this.$element.attr(CATEGORIES)) !== 'undefined';
		this.dataSet = {};

		this.loadItemsIntoTemplate();
	}

	init() {
		var obj = this;
		Sortable.create(this.element, {
			onSort: function (evt) {}
		});

		this.$saveButton.click(this.applySortOrder.bind(this));
		this.$resetButton.click(this.loadItemsIntoTemplate.bind(this));
	}

	loadItemsIntoTemplate() {
		if (this.categoryMode) {
			this.itemTemplate = $(CATEGORY_TEMPLATE_SELECTOR).html();
			this.loadCategories();
		}
		else {
			this.itemTemplate = $(TEMPLATE_SELECTOR).html();
			this.loadProducts();
		}
	}

	applySortOrder() {
		if (this.categoryMode) {
			this.setCategorySortOrder();
		}
		else {
			this.setSortOrder();
		}
	}

	loadProducts() {
		const url = `${this.options.loadProductsEndpointUrl}?${this.options
			.endpointParam1}=${this.categoryId}`;
		this.resetNoResults();
		$.ajax({
			url,
			method: 'post',
			success: result => {
				this.$element.empty();
				for(var i=0;i<result.length;i++) {
					const newItem = mustache(this.itemTemplate, {
						imageUrl:result[i].ImageUrl,
						sku:result[i].Sku,
						name:result[i].Name,
						type:result[i].Type
					});
					const $newItem = $(newItem);
					$newItem.appendTo(this.$element);
				}
				if (result.length ==0) {
					this.noResults();
				}
				this.init();
			},
			error: e => {


			}
		}).done(() => {
		});
	}

	noResults() {
		this.$noResults.show();
		this.$saveButton.hide();
		this.$resetButton.hide();
	}

	resetNoResults() {
		this.$element.empty();
		this.$noResults.hide();
		this.$saveButton.show();
		this.$resetButton.show();
	}

	loadCategories() {
		const url = `${this.options.loadCategoriesEndpointUrl}?${this.options
			.endpointParam1}=${this.categoryId}`;
		this.resetNoResults();
		$.ajax({
			url,
			method: 'post',
			success: result => {
				this.$element.empty();
				for(var i=0;i<result.length;i++) {
					const newItem = mustache(this.itemTemplate, {
						imageUrl:result[i].ImageUrl,
						sku:result[i].Sku,
						name:result[i].Name
					});
					const $newItem = $(newItem);
					$newItem.appendTo(this.$element);
				}
				if (result.length ==0) {
					this.noResults();
				}
				this.init();
			},
			error: e => {
				this.noResults();
			}
		}).done(() => {
		});
	}

	getSortOrder() {
		var dataSet = Array();

		this.$element.find(ID_ELEMENT_SELECTOR).each(function(e, i) {
			var sku = $(this).attr(ID_SELECTOR);
			dataSet.push(sku);
		});

		this.dataSet= dataSet;
	}

	setSortOrder() {
		this.getSortOrder();
		this.$loadingPanel.addClass(LOADING_PANEL_TOGGLE_CLASS);
		var token = $('#__AjaxAntiForgeryForm input[name="__RequestVerificationToken"]').val();
		const url = `${this.options.endpointUrl}`;
		var dataPost = {
			categoryId:this.categoryId,
			products:this.dataSet,
 			__RequestVerificationToken: token
		};

		$.ajax({
			url,
			contentType: 'application/json; charset=utf-8',
			data:JSON.stringify(dataPost),
			method: 'post',
			success: result => {
				this.$loadingPanel.removeClass(LOADING_PANEL_TOGGLE_CLASS);
			},
			error: e => {
				this.$loadingPanel.removeClass(LOADING_PANEL_TOGGLE_CLASS);
			}
		}).done(() => {
			this.$loadingPanel.removeClass(LOADING_PANEL_TOGGLE_CLASS);
		});
	}

	setCategorySortOrder() {
		this.getSortOrder();
		this.$loadingPanel.addClass(LOADING_PANEL_TOGGLE_CLASS);
		var token = $('#__AjaxAntiForgeryForm input[name="__RequestVerificationToken"]').val();
		const url = `${this.options.categoriesEndpointUrl}`;
		var dataPost = {
			categoryId:this.categoryId,
			categories:this.dataSet,
 			__RequestVerificationToken: token
		};
		$.ajax({
			url,
			method: 'post',
			contentType: 'application/json; charset=utf-8',
			data:JSON.stringify(dataPost),
			success: result => {
				this.$loadingPanel.removeClass(LOADING_PANEL_TOGGLE_CLASS);
			},
			error: e => {
				this.$loadingPanel.removeClass(LOADING_PANEL_TOGGLE_CLASS);
			}
		}).done(() => {
			this.$loadingPanel.removeClass(LOADING_PANEL_TOGGLE_CLASS);
		});
	}
}

SortableProducts.DEFAULTS = {
	loadProductsEndpointUrl: $(`meta[name="site.sortableProductsLoadApiEndpoint"]`).attr('content'),
	endpointUrl: $(`meta[name="site.sortableProductsApiEndpoint"]`).attr('content'),
	loadCategoriesEndpointUrl: $(`meta[name="site.sortableCategoriesLoadApiEndpoint"]`).attr('content'),
	categoriesEndpointUrl: $(`meta[name="site.sortableCategoriesApiEndpoint"]`).attr('content'),
	endpointParam: 'products',
	endpointParam1: 'categoryId',
	endpointParam2: 'categories',
};

plugin(PLUGIN_NAME, SortableProducts);

export function exec() {
	$(document).ready(() => {
	   $(ELEMENT_SELECTOR)[PLUGIN_NAME]();
	});
}




// WEBPACK FOOTER //
// ./project/client/src/core/modules/sortable-products/index.js